import { TextField, Autocomplete } from "@mui/material";
import { useState, useEffect, type SyntheticEvent } from "react";

type DamageOption = {
  id: number;
  name: string;
};

const damageOptions: DamageOption[] = [
  { id: 0, name: "無" },
  { id: 1, name: "有" },
  { id: 2, name: "未設定" },
  { id: 9, name: "設定しない" },
];

type DamageSelectProps = {
  changedValue: (value: number | undefined) => void;
  inputValue: number;
};

export default function DamageSelect({
  changedValue,
  inputValue,
}: DamageSelectProps) {
  const initialValue = damageOptions.find(
    (element) => element.id === parseInt(String(inputValue), 10)
  );
  const [value, setValue] = useState<DamageOption | undefined>(initialValue);

  useEffect(() => {
    if (inputValue !== undefined && inputValue !== null) {
      const newValue = damageOptions.find((item) => item.id === inputValue);
      setValue(newValue);
    }
  }, [inputValue]);

  const handleChange = (
    _event: SyntheticEvent,
    newValues: DamageOption | null
  ) => {
    setValue(newValues ?? undefined);
    changedValue(newValues?.id);
  };

  return (
    <Autocomplete
      fullWidth
      size="small"
      options={damageOptions}
      getOptionLabel={(option) => (option.name ? option.name : "")}
      isOptionEqualToValue={(option, selected) => option.id === selected.id}
      renderInput={(params) => <TextField {...params} />}
      onChange={handleChange}
      value={value ?? null}
      sx={{ cursor: "pointer", pointerEvents: "auto" }}
    />
  );
}
